export class ColumnWidthsValueConverter {
  toView(columnWidths: string, i: number): string {
    let width = columnWidths?.split(',')[i];
    switch (width) {
      case undefined:
        return '';
      case '0':
        return 'display:none;';
      case 'auto':
        return 'width: auto; max-width: auto';
      default:
        return `width: ${width}px; max-width: ${width}px`
    }
  }
}
